import { Directive, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

@Directive({ selector: '[scrollNearEnd]' })
export class IntersectionListenerDirective implements OnInit {
  @Output() nearEnd: EventEmitter<void> = new EventEmitter<void>();
  @Output() nearTop: EventEmitter<void> = new EventEmitter<void>();

  /**
   * threshold in PX when to emit before page end scroll
   */
  @Input() threshold = 400;

  constructor() {}

  ngOnInit(): void {

  }

  @HostListener('scroll', ['$event.target'])
  windowScrollEvent(event: Element) {
    // how big in pixels the element is
    const heightOfElement = event.scrollHeight;

    // currently scrolled Y position
    const currentScrolledY = event.scrollTop;

    // height of opened window - shrinks if console is opened
    // @ts-ignore
    const innerHeight = event.offsetHeight;

    // calculated whether we are near the end
    const scrollToBottom =
      heightOfElement - innerHeight - currentScrolledY;
    const scrollToTop = currentScrolledY;
    // if the user is near end
    if (scrollToBottom < this.threshold) {
      this.nearEnd.emit();
    }

    if (scrollToTop < this.threshold) {
      this.nearTop.emit();
    }
  }
}
